var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { CustomerDetailComponent } from './../customer-detail/customer-detail.component';
import { ContactHistoryComponent } from './../contact-history/contact-history.component';
import { DepositorInfoComponent } from './../depositor-info/depositor-info.component';
import { CustomerDaDataComponent } from './../customer-da-data/customer-da-data.component';
import { CustomerReqDocComponent } from './../customer-req-doc/customer-req-doc.component';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CustomerProfileComponent } from '@app/customer-profile/customer-profile.component';
var CustomerComponent = /** @class */ (function () {
    function CustomerComponent(apiService, util, activatedRoute) {
        this.apiService = apiService;
        this.util = util;
        this.activatedRoute = activatedRoute;
        this.contactId = "";
        this.emailaddress1 = "";
        this.telephone1 = "";
        this.dpa_idcard = "";
        this.fullname = "";
        this.selectedSms = "";
        this.smsText = "";
        this.submittedSms = false;
        this.selectedEmail = "";
        this.emailText = "";
        this.submittedEmail = false;
        this.attachments = "";
        this.role = {};
        this.isCrisis = true;
    }
    CustomerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.isCrisis = this.cookieData.isCrisis;
                        if (!this.isCrisis) {
                            $(this.Depositor.nativeElement).removeAttr("data-toggle");
                            $(this.Depositor.nativeElement).removeAttr("href");
                            $(this.Depositor.nativeElement).addClass("disabled");
                            $(this.DATab.nativeElement).removeAttr("data-toggle");
                            $(this.DATab.nativeElement).removeAttr("href");
                            $(this.DATab.nativeElement).addClass("disabled");
                            $(this.ReqDocTab.nativeElement).removeAttr("data-toggle");
                            $(this.ReqDocTab.nativeElement).removeAttr("href");
                            $(this.ReqDocTab.nativeElement).addClass("disabled");
                        }
                        this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
                        return [4 /*yield*/, this.callApi()
                            //await this.initDropdown()
                        ];
                    case 1:
                        _a.sent();
                        //await this.initDropdown()
                        try {
                            $('#summernote').summernote({
                                placeholder: '',
                                tabsize: 2,
                                height: 120,
                                toolbar: [
                                    ['style', ['style']],
                                    ['font', ['bold', 'underline', 'clear']],
                                    ['color', ['color']],
                                    ['para', ['ul', 'ol', 'paragraph']],
                                    ['table', ['table']],
                                    ['insert', ['link', 'picture', 'video']],
                                    ['view', ['fullscreen', 'codeview', 'help']]
                                ]
                            });
                        }
                        catch (e) {
                            this.util.ShowWaiting(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerComponent.prototype.callApi = function () {
        return forkJoin([
            this.initDropdown()
        ]);
    };
    CustomerComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "externalSmsTemplate")];
                    case 1:
                        _a.smsTemplate = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("master", "externalEmailTemplate")];
                    case 2:
                        _b.emailTemplate = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
    };
    CustomerComponent.prototype.sms = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.telephone1 == null || !this.util.isValidTelNo(this.telephone1)) {
                    this.util.WarningDialog("SMS ไม่ถูกต้อง");
                }
                else {
                    $("#smsModal").modal('show');
                }
                return [2 /*return*/];
            });
        });
    };
    CustomerComponent.prototype.email = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.emailaddress1 == null || !this.util.isValidEmail(this.emailaddress1)) {
                    this.util.WarningDialog("Email ไม่ถูกต้อง");
                }
                else {
                    this.selectedEmail = "";
                    this.emailText = "";
                    this.attachments = "";
                    this.submittedEmail = false;
                    $('#summernote').summernote('code', '');
                    $("#emailModal").modal('show');
                }
                return [2 /*return*/];
            });
        });
    };
    CustomerComponent.prototype.confirmSMS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedSms = true;
                        if (!(this.selectedSms != "")) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        req = {
                            contactid: this.contactId,
                            dpa_description: "",
                            dpa_phoneno: this.telephone1,
                            template: this.selectedSms,
                            dpa_createdby: this.cookieData.userId
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendSms", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            $("#smsModal").modal('hide');
                            this.util.SuccessDialog("ส่ง SMS สำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ");
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CustomerComponent.prototype.confirmEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedEmail = true;
                        if (!(this.selectedEmail != "")) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        req = {
                            contactid: this.contactId,
                            dpa_name: "",
                            dpa_description: $('#summernote').summernote('code'),
                            //dpa_emailaddress: this.emailaddress1,
                            //template: this.selectedEmail,
                            dpa_createdby: this.cookieData.userId,
                            dpa_customwebuserid: this.cookieData.userId,
                            dpa_callby: 1
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmail2", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.util.SuccessDialog("ส่ง Email สำเร็จ");
                            $("#emailModal").modal('hide');
                        }
                        else {
                            this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ");
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CustomerComponent.prototype.smsChange = function () {
        var _this = this;
        var selectd = this.smsTemplate.filter(function (e) { return e.dpa_externalsmstemplateid == _this.selectedSms; });
        if (selectd != null && selectd.length > 0) {
            this.smsText = selectd[0].dpa_templatebodysms;
        }
        else {
            this.smsText = "";
        }
    };
    CustomerComponent.prototype.emailChange = function () {
        var _this = this;
        var selectd = this.emailTemplate.filter(function (e) { return e.templateid == _this.selectedEmail; });
        if (selectd != null && selectd.length > 0) {
            this.emailText = selectd[0].body;
            $('#summernote').summernote('code', this.emailText);
            this.attachments = selectd[0].attachments.join(",");
        }
        else {
            this.emailText = "";
            this.attachments = "";
        }
    };
    CustomerComponent.prototype.onProfileTabClick = function () {
        console.log("onProfileTabClick");
        this.profile.init(this.contact);
    };
    CustomerComponent.prototype.onDetailTabClick = function () {
        console.log("onDetailTabClick");
        this.detail.init(this.contactId);
    };
    CustomerComponent.prototype.onHistoryTabClick = function () {
        console.log("onHistoryTabClick");
        this.history.init(this.contactId, this.fullname);
    };
    CustomerComponent.prototype.onDepositorTabClick = function () {
        if (this.isCrisis) {
            console.log("onDepositorTabClick");
            this.depositor.init(this.contact);
        }
    };
    CustomerComponent.prototype.onDATabClick = function () {
        if (this.isCrisis) {
            console.log("onDaTabClick");
            this.da.init(this.contactId);
        }
    };
    CustomerComponent.prototype.onreqdocTabClick = function () {
        if (this.isCrisis) {
            console.log("onDaTabClick");
            this.reqdoc.init(this.contactId);
        }
    };
    CustomerComponent.prototype.GetSavedContact = function (contact) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (contact != null) {
                    this.contact = contact;
                    this.emailaddress1 = contact.emailaddress1;
                    this.telephone1 = contact.telephone1;
                    this.dpa_idcard = contact.dpa_idcard;
                    this.fullname = (contact.firstname == null ? "" : contact.firstname) + " " + (contact.lastname == null ? "" : contact.lastname);
                }
                return [2 /*return*/];
            });
        });
    };
    return CustomerComponent;
}());
export { CustomerComponent };



// WEBPACK FOOTER //
// ./src/app/customer/customer.component.ts.pre-build-optimizer.js